export default class TaxObligationCommentPayload {
    comment = '';
}
